import {
  setCookie,
  getCookie,
} from './utils'

// Replace these with your real Klaviyo values if they differ from the main form
const KLAVIYO_PUBLIC_KEY = 'Y6QdGU'; 
const KLAVIYO_LIST_ID = 'UDdXed';    

const popupEmail = document.getElementById("email--popup");
const popupPhone = document.getElementById("phone--popup");
const popupError = document.getElementById("contact-error--popup");

document.querySelector('.button--popup').addEventListener('click', function (e) {
  e.preventDefault();

  const emailVal = popupEmail.value.trim();
  let phoneVal = popupPhone ? popupPhone.value.trim() : '';

  // Auto-format phone to E.164 (US/Canada assumption)
  if (phoneVal !== '') {
    phoneVal = phoneVal.replace(/\D/g, '');
    if (phoneVal.length === 10) phoneVal = '+1' + phoneVal;
    else if (phoneVal.length === 11 && phoneVal.startsWith('1')) phoneVal = '+' + phoneVal;
  }

  if(emailVal !== '' || phoneVal !== '') {
    document.querySelector('.popup--email-capture__success').style.display = 'none';
    if (popupError) popupError.style.display = 'none';
    document.querySelector('.button--popup').classList.add('loading');

    // Build attributes ONLY if they exist
    const profileAttributes = {};

    if (emailVal !== '') {
      profileAttributes.email = emailVal;
    }

    if (phoneVal !== '') {
      profileAttributes.phone_number = phoneVal;
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'accept': 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        'revision': '2024-02-15' 
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      })
    })
    .then(async function (response) {
      if (!response.ok) {
        // THIS IS THE MAGIC PART: Let's read Klaviyo's exact error message
        const errData = await response.json();
        console.error('Klaviyo API Error Details:', JSON.stringify(errData, null, 2));
        throw new Error('Klaviyo error: ' + response.status);
      }
      
      document.querySelector('.popup--email-capture__success').style.display = 'block';
      document.querySelector('.button--popup').classList.remove('loading');
      
      popupEmail.value = '';
      if (popupPhone) popupPhone.value = '';
    })
    .catch(function (err) {
      console.error(err);
      document.querySelector('.button--popup').classList.remove('loading');
    });

  } else {
    document.querySelector('.popup--email-capture__success').style.display = 'none';
    if (popupError) popupError.style.display = 'block';
  }
});

// Popup display and cookie logic
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var popupShownSession = sessionStorage.getItem('popupShown')
    var visits

    if(getCookie('visits')) {
      visits = parseInt(getCookie('visits')) + 1
    } else {
      visits = 0
    }

    setCookie('visits', visits, 1)

    if(popupShownSession != 'shown' && visits < 2 && getCookie('closed') != 'yes'){
      document.getElementById('shopify-section-email-capture-popup').classList.add('popup--active')
      sessionStorage.setItem('popupShown', 'shown')
    }
  }, 10000);

  const closePopup = () => {
    document.getElementById('shopify-section-email-capture-popup').classList.remove("popup--active");
    document.getElementById('shopify-section-email-capture-popup').setAttribute("aria-hidden", true);
    setCookie('closed', 'yes', 1)
  };
  
  document.querySelectorAll(".popup__close-button").forEach((button) => {
    button.addEventListener("click", () => {
      closePopup();
    });
  });
  
  document.querySelectorAll(".popup__overlay").forEach((overlay) => {
    overlay.addEventListener("click", () => {
      closePopup();
    });
  });
  
  document.addEventListener("keydown", (e) => {
    if (e.keyCode == 27) {
      closePopup();
    }
  });
});